import Enum from './Domain'

class CpfCnpj extends Enum { }

CpfCnpj.initEnum(['CPF', 'CNPJ'])

export default CpfCnpj
